// src/pages/CategoryPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../components/SEO';
// ❌ Removed BlogHeader import
import BlogLayout from '../components/BlogLayout';

const CategoryPage = () => {
  const { categorySlug } = useParams();
  
  const title = `Posts in ${categorySlug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}`;

  return (
    <>
      <SEO
        title={`${title} | Oolook Logbook`}
        description={`Browse all articles in the ${title} category on the Oolook blog.`}
      />
      {/* ❌ Removed BlogHeader component */}
      <main className="bg-dark-bg pt-24 sm:pt-32"> {/* ✅ Added top padding */}
        <BlogLayout 
          filterType="category"
          filterValue={categorySlug}
        />
      </main>
    </>
  );
};

export default CategoryPage;